import React from 'react';
import {Filter} from 'components/Ui/Icon';
import Modal from './Modal';
import useSearchParams from '../useSearchParams';
import Sort from '../Sort';
import {useCurrentClientQuery} from 'api';

export default () => {
  const [visible, setVisible] = React.useState(false);
  const {query, setQuery} = useSearchParams();
  const {data: {currentClient: {currentScoreContract = null} = {}} = {}} =
    useCurrentClientQuery({
      fetchPolicy: 'cache-and-network',
    });

  // Calculate ToDo filter count
  const todoFilterCount = [
    query.assignees?.length > 0,
    query.types?.length > 0,
    query.priorities?.length > 0,
  ].filter(Boolean).length;

  // Calculate Lead filter count
  const leadFilterCount = [
    query.prospectScore?.from || query.prospectScore?.to,
    query.totalScoreRanks?.length > 0,
  ].filter(Boolean).length;

  const numberOfFiltersInUse = todoFilterCount + leadFilterCount;

  const handleSortFieldChange = (sortField: string) => {
    setQuery({
      sortField,
      page: 1,
    });
  };

  const handleSortOrderToggle = () => {
    const newOrder = query.sortOrder === 'desc' ? 'asc' : 'desc';
    setQuery({
      sortOrder: newOrder,
      page: 1,
    });
  };

  return (
    <>
      <div className="flex items-center gap-4">
        <button
          onClick={() => setVisible(true)}
          className="relative border border-c-border rounded w-9 h-9 bg-white text-c-lighti cursor-pointer flex items-center justify-center"
        >
          <Filter
            color={
              numberOfFiltersInUse > 0
                ? 'var(--primary)'
                : 'var(--text-color-3)'
            }
          />
          {numberOfFiltersInUse > 0 && (
            <span className="absolute right-[-5px] top-[-5px] rounded bg-c-primary min-w-[14px] h-[14px] flex items-center justify-center text-xs text-white">
              {numberOfFiltersInUse}
            </span>
          )}
        </button>
        <div className="flex items-center gap-4">
          {todoFilterCount > 0 && (
            <div className="flex items-center gap-1">
              <span className="text-sm">ToDo</span>
              <span className="text-xs bg-[#DDEFFF] text-primary rounded-full h-4 min-w-[16px] flex items-center justify-center">
                {todoFilterCount}
              </span>
            </div>
          )}
          {leadFilterCount > 0 && (
            <div className="flex items-center gap-1">
              <span className="text-sm">リード</span>
              <span className="text-xs bg-[#DDEFFF] text-primary rounded-full h-4 min-w-[16px] flex items-center justify-center">
                {leadFilterCount}
              </span>
            </div>
          )}
        </div>
        <Sort
          sortField={query.sortField}
          sortOrder={query.sortOrder}
          onSortFieldChange={handleSortFieldChange}
          onSortOrderToggle={handleSortOrderToggle}
          hasScoreContract={currentScoreContract?.isActive}
        />
      </div>
      <Modal visible={visible} onClose={() => setVisible(false)} />
    </>
  );
};
